import { useRouter } from 'next/router';
import { Box, Button, IconButton, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// Hooks
import { useCartContext } from '@/providers/CartProvider';
import { useStoreContext } from '@/providers/StoreProvider';
import { useCheckoutContext } from '@/providers/CheckoutProvider';
// Utils
import { routes } from '@/routes/routes';
import { formatAmount } from '@/utils/index';
import { config } from 'config';
// Styles & Assets
import { colors } from '@/theme';
import storeBanner from '@/images/StoreBanner.png';

export default function CreditBanner() {
  const router = useRouter();
  const { couponState, handleShowCouponBanner } = useCheckoutContext();
  const { addItemToCart } = useCartContext();
  const { smartNode } = useStoreContext();

  const bannerBgUrl = config.marketingFunnel.shoppingBannerImage;
  const isValidUrl = bannerBgUrl?.includes('http');

  const handleUseCredit = () => {
    addItemToCart({ productId: smartNode?.id }).then(() => {
      router.push(routes.cart.path);
    });
  };

  return (
    <Paper
      sx={{
        padding: '24px',
        marginBottom: '24px',
        backgroundColor: colors.primary.light,
        background: `url(${isValidUrl ? bannerBgUrl : storeBanner.src}) `,
        width: '100%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        position: 'relative',
      }}
      elevation={1}
    >
      <IconButton
        onClick={() => handleShowCouponBanner(false)}
        size="small"
        sx={{
          position: 'absolute',
          right: 6,
          top: 6,
        }}
        data-core-qa="storeButtonCloseBanner"
      >
        <CloseIcon sx={{ fill: colors.common.white }} fontSize="small" />
      </IconButton>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          marginBottom: '24px',
        }}
      >
        <Typography variant="body1">Credit Available</Typography>
        <Box>
          <Typography variant="h2" color={colors.common.white}>
            {`$${formatAmount(couponState?.couponTotalUsd, 0)} Off`}
          </Typography>
          <Typography variant="body1">Minimum cart of $2,000</Typography>
        </Box>
        <Typography variant="h3">{`${smartNode?.name ?? 'Smart Node'}`}</Typography>
      </Box>
      <Box>
        <Button
          variant="contained"
          onClick={handleUseCredit}
          data-core-qa="storeButtonBuyNow"
        >
          Buy Now
        </Button>
      </Box>
    </Paper>
  );
}
